<template>
  <AppBarLayout>
    <template #default>
      <div
        ref="containerRef"
        class="tw-w-full tw-h-full tw-relative tw-overflow-x-hidden sm:tw-min-w-[400px] tw-py-[0px] tw-px-[0px] md:tw-py-[0px] main"
        @scroll="onScroll"
      >
        <BrandPattern ref="animationRef" page="APPBARLAYOUT" />
        <BackgroundComponent />
        <ActivePathWrapper
          :active-hierarchy="[
            getComponentUiText('app-menu-assess-1'),
            getComponentUiText('app-menu-submenu-assess-manage-assessments-1'),
            getComponentUiText(
              'app-menu-submenu-assess-assessments-input-complete-1',
            ),
          ]"
          :navigate="['', '/assess/manage', '']"
        />
        <div id="clickbox-access" ref="clickboxAccessRef">
          <div
            class="tw-z-[1] tw-relative tw-flex tw-gap-[20px] md:tw-gap-[20px] tw-flex-col main-body"
          >
            <div
              class="tw-py-[40px] md:tw-py-[63px] tw-flex tw-gap-[40px] tw-flex-col tw-bg-white tw-px-[10px] xl:tw-px-[60px] border_bottom"
            >
              <div
                class="tw-flex tw-items-center tw-flex-col tw-gap-[5px] md:tw-gap-[none] md:tw-flex-row tw-w-full tw-justify-between titleWrapper tw-max-w-[1361px]"
              >
                <div class="title tw-flex tw-gap-1">
                  <span id="assess-manage-title">
                    {{
                      getComponentUiText(
                        "app-assessment-input-title-1",
                        false,
                        {
                          checklistId: checklistData.checklistId
                            ? checklistData.checklistId
                            : "",
                          checklistName: "",
                        },
                      )
                    }}
                  </span>

                  <div id="assess-manage-subtitle" class="subTitle">
                    {{
                      checklistData.checklistId
                        ? checklistData.checklistName
                        : ""
                    }}
                  </div>
                </div>
                <div
                  id="assess-settings"
                  style="
                    border-radius: 6px;
                    border: 1px solid var(--UI-rule, #eff0f1);
                    background: var(--UI-white, #fff);
                    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
                    width: 49px;
                    height: 45px;
                  "
                >
                  <popoverAssessment
                    v-if="!isLoadingAnimation"
                    :id-popover="'popover-btn-bulk-action-assessment-input'"
                    data-cy-id="assessment-input-settings"
                    :style-button="`btn-popover`"
                    b-popover="popover-has-tag"
                  >
                    <CustomDropDownItem
                      v-for="(item, index) in items"
                      :key="`option_input_${index}`"
                      :is-show-option="item.isShow"
                      :id-text="`${item.text}`"
                      :custom-text-class="`tw-flex tw-items-center tw-gap-[5px] tw-w-[90%] !tw-text-[13px] !tw-font-normal !tw-leading-[19.5px] ${
                        item.arrowRed ? 'tw-text-[#F7553C]' : ''
                      } tw-whitespace-normal`"
                      :arrow-icon-style="`${
                        item.arrowRed
                          ? 'tw-text-[#F7553C]'
                          : 'tw-text-[#387DFF]'
                      } tw-min-w-[7px]`"
                      :padding="'tw-px-[13px] tw-py-[12px]'"
                      :custom-class="'tw-flex tw-justify-between tw-items-center !tw-border-0'"
                      :tag-status="item.statusTag"
                      :tag-status-id="item.statusTagId"
                      :data-cy-id="`assessment-input-settings-item-${index}`"
                      @click="() => item.action()"
                    />
                  </popoverAssessment>
                  <div v-else class="tw-h-[38px] tw-w-[38px]">
                    <!-- eslint-disable vue/no-unused-refs -->
                    <LottieAnimation
                      ref="anim"
                      :animation-data="ProgressAnimation"
                      :auto-play="true"
                      :loop="true"
                    />
                  </div>
                </div>
              </div>
              <div class="tw-flex tw-w-full">
                <AssessmentCardWrapper
                  class="tw-justify-between 2xl:tw-flex-nowrap tw-w-full"
                  :detail="checklistAssessementById"
                  :contributors-card="checklistIdParam"
                />
              </div>
            </div>
            <div
              class="tw-mb-[0px] assessment-container tw-px-[10px] xl:tw-px-[60px]"
            >
              <div class="tw-gap-[40px] xl:tw-gap-[60px] content">
                <div class="tw-flex tw-flex-col tw-gap-[20px] table-content">
                  <div
                    class="tw-flex tw-w-full tw-gap-[60px] container-content tw-mb-[140px] 2xl:tw-mb-[0px]"
                  >
                    <div
                      id="assess-questions"
                      class="tw-flex-1 tw-flex tw-flex-col xl:tw-min-w-[1060px] tw-min-w-full tw-max-w-[1060px]"
                    >
                      <div
                        class="tw-sticky tw-top-0 tw-z-[99] tw-bg-[#F7F7F7] tw-pb-[20px] md:tw-pt-[20px]"
                      >
                        <div id="assess-manager-title" class="tw-mb-[20px]">
                          <AssessmentCategoryHeader
                            :title="
                              progressCategories[indexActiveCategory]
                                ?.checklistItemCategoryLabel
                            "
                            :search-list-question="searchListQuestion"
                            :inital-value-search="valueSearch"
                            :is-flashing="isFlashing"
                            @current-value-search="currentValue"
                            @open-wide-search="
                              (value) => {
                                isShowFilterAction = false;
                              }
                            "
                          />
                        </div>

                        <div
                          class="tw-flex tw-w-full tw-justify-between tw-flex-col md:tw-flex-row"
                        >
                          <div id="assess-manager-search-box" class="tw-flex-1">
                            <SearchBox
                              :hint-text="
                                getComponentUiText(
                                  'app-prospect-questions-search-text-1',
                                )
                              "
                              :active-category="
                                progressCategories[indexActiveCategory] || 0
                              "
                              :search-list-question="searchListQuestion"
                              :inital-value-search="valueSearch"
                              @current-value-search="currentValue"
                            />
                          </div>
                          <AssessmentViewToggle
                            :selected-questions="selectedQuestions"
                            :list-questions-selected="listQuestionsSelected"
                            :list-questions-active="
                              listQuestion
                                .map((arr) => arr.checklistChildren || [])
                                .flat()
                            "
                            :is-loading="isLoadingQuestion"
                            :target-filter="
                              fiterTargetOption.sort(
                                (a, b) => (a.order || 0) - (b.order || 0),
                              )
                            "
                            @update:view="updateView"
                            @update:filter="handleApplyFilter"
                            @update:loading="
                              (value) => (isLoadingQuestion = value)
                            "
                            @update:selected-questions-after-selected="
                              selectedQuestions = $event
                            "
                          />

                          <div class="filter-action">
                            <ButtonFilter
                              :active="
                                fiterTargetOption.length > 0 &&
                                !isLoadingQuestion
                              "
                              :is-filter="
                                originSelected.filter(
                                  (item) => !item.value.isDefault,
                                ).length > 0
                              "
                              :show-more-actions="isShowFilterAction"
                              :id-popover="'popoverBtnFilterMainAssessment'"
                              :is-margin-right="false"
                              button-class="!tw-h-[46px] tw-ml-5"
                              @click="handleShowFilterAction"
                              @click-away="outsideFilterModal = true"
                            >
                              <FilterModal
                                :targets="fiterTargetOption"
                                :is-date="false"
                                :is-search="false"
                                :type="FILTER_MODAL_TYPE.mainChecklist"
                                :show-more-actions="isShowFilterAction"
                                :filter-selected="filterSelected"
                                :outside-filter-modal="outsideFilterModal"
                                :original-data="{
                                  filterSelected: cloneDeep(originSelected),
                                }"
                                @update:apply-filter="handleApplyFilter"
                              />
                            </ButtonFilter>
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="view === assessmentViews.default"
                        class="tw-flex-1 tw-flex tw-flex-col tw-gap-[20px] xl:tw-min-w-[1060px] tw-min-w-full tw-max-w-[1060px] tw-pb-[20px]"
                      >
                        <div
                          v-if="
                            currentQuestions.length === 0 &&
                            isLoadingQuestion === false
                          "
                          class="tw-flex tw-items-center tw-justify-center tw-text-[#878787] tw-text-[13px] tw-font-[500] tw-leading-[145%] tw-mt-[20px]"
                        >
                          {{
                            getComponentUiText(
                              "app-assess-recommendations-assessment-category-empty-message-1",
                            )
                          }}
                        </div>
                        <div
                          v-if="
                            listQuestion &&
                            listQuestion.length &&
                            isMounted &&
                            !isLoadingQuestion
                          "
                          class="tw-flex tw-flex-col tw-gap-5"
                        >
                          <AssessmentQuestionSubCategory
                            v-for="(item, index) in currentQuestions"
                            :key="`${item.checklistItemId}`"
                            v-model:selected-questions="selectedQuestions"
                            :checklist-status="statusDetails.checklistStatusId"
                            :hide-complete="hideComplete"
                            :order-number="item.orderNumber || index"
                            :question="item"
                            @exclude-item="toggleCheckListItem"
                            @clear-filter="clearFilter"
                            @update:selected-questions="
                              selectedQuestions = $event
                            "
                          />
                        </div>
                        <div
                          v-else
                          class="tw-right-sidebar skeleton-domain-sidebar"
                        >
                          <AssessmentQuestionSubCategorySkeleton>
                          </AssessmentQuestionSubCategorySkeleton>
                        </div>
                        <div
                          v-if="isLoadingNewData && !isLoadingQuestion"
                          class="tw-right-sidebar skeleton-domain-sidebar"
                        >
                          <AssessmentLoadmoreSkeleton />
                        </div>
                      </div>
                      <div
                        v-if="view === assessmentViews.list"
                        class="tw-flex-1 tw-flex tw-flex-col tw-gap-[20px] xl:tw-min-w-[1060px] tw-min-w-full tw-max-w-[1060px] tw-pb-[20px]"
                      >
                        <div
                          v-if="
                            currentQuestions.length === 0 &&
                            isMounted &&
                            isLoadingQuestion === false
                          "
                          class="tw-flex tw-items-center tw-justify-center tw-text-[#878787] tw-text-[13px] tw-font-[500] tw-leading-[145%] tw-mt-[20px]"
                        >
                          {{
                            getComponentUiText(
                              "app-assess-recommendations-assessment-category-empty-message-1",
                            )
                          }}
                        </div>
                        <div
                          v-if="
                            listQuestion &&
                            listQuestion.length &&
                            isMounted &&
                            !isLoadingQuestion
                          "
                        >
                          <AssessmentQuestionSubCategoryList
                            v-for="(item, index) in currentQuestions"
                            :key="item.checklistItemId"
                            v-model:selected-questions="selectedQuestions"
                            :hide-complete="hideComplete"
                            :order-number="item.orderNumber || index"
                            :checklist-id="item.checklistItemId"
                            :sub-question="item.checklistChildren"
                            :question="item"
                            @clear-filter="clearFilter"
                            @exclude-item="toggleCheckListItem"
                          />
                        </div>
                        <div
                          v-else
                          class="tw-right-sidebar skeleton-domain-sidebar"
                        >
                          <AssessmentQuestionSubCategorySkeleton>
                          </AssessmentQuestionSubCategorySkeleton>
                        </div>
                        <div
                          v-if="isLoadingNewData && !isLoadingQuestion"
                          class="tw-right-sidebar skeleton-domain-sidebar"
                        >
                          <AssessmentLoadmoreSkeleton />
                        </div>
                      </div>

                      <div
                        class="tw-flex tw-mt-[30px] tw-justify-between tw-items-center"
                      >
                        <div>
                          <span
                            class="tw-font-Poppins tw-text-[13px] tw-font-[500] tw-text-[#211F58]"
                          >
                            {{
                              progressCategories[indexActiveCategory]
                                ?.checklistItemCategoryCompleted
                            }}/{{
                              progressCategories[indexActiveCategory]
                                ?.checklistItemCategoryCount
                            }}
                            {{
                              getComponentUiText(
                                "app-component-assessments-questions-answered-1",
                              )
                            }}</span
                          >
                        </div>
                        <div class="tw-flex tw-gap-[10px]">
                          <Button1
                            :class="['previous-button tw-font-normal']"
                            :title="
                              getComponentUiText(
                                'app-prospect-questions-button-previous-1',
                              )
                            "
                            :sub-title="
                              indexActiveCategory > 0
                                ? progressCategories[indexActiveCategory - 1]
                                    ?.checklistItemCategoryLabel
                                : ''
                            "
                            :disabled="
                              isLoadingQuestion || indexActiveCategory === 0
                            "
                            data-cy="assessment-input-previous-button"
                            @click="changeActiveCategory(false)"
                          />
                          <Button1
                            class="next-button tw-font-normal"
                            :title="
                              getComponentUiText(
                                'app-assessments-checklists-assessment-button-next-1',
                              )
                            "
                            :sub-title="
                              indexActiveCategory <=
                              progressCategories.length - 1
                                ? progressCategories[indexActiveCategory + 1]
                                    ?.checklistItemCategoryLabel
                                : ''
                            "
                            :disabled="
                              isLoadingQuestion ||
                              indexActiveCategory >=
                                progressCategories.length - 1
                            "
                            data-cy="assessment-input-next-button"
                            @click="changeActiveCategory(true)"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Category block -->
                    <div
                      :class="[
                        '2xl:tw-sticky 2xl:tw-top-0 2xl:tw-bg-[#f7f7f7] category-block tw-w-[100%] tw-flex tw-flex-col tw-gap-[20px] tw-justify-center tw-rounded-br-md tw-rounded-bl-md tw-h-[fit-content] progressBlock lg:tw-min-w-[241px]',
                        progressCategories[indexActiveCategory]
                          ?.checklistItemCategoryLabel
                          ? 'tw-pt-[67px]'
                          : 'tw-pt-[40px]',
                      ]"
                    >
                      <AssessmentCategoryDetail
                        v-if="
                          progressCategories &&
                          progressCategories.length &&
                          !categoryLoading
                        "
                        :checklist-id="checklistIdParam"
                        :title="
                          getComponentUiText(
                            'app-component-assessments-category-detail-title-1',
                          )
                        "
                        :progress-categories="progressCategories"
                        @scroll-to-top="scrollToTop"
                      />

                      <AssessmentCategoryDetailSkeleton v-else />

                      <AssessmentProgress
                        v-if="
                          progressCategories &&
                          progressCategories.length &&
                          !categoryLoading
                        "
                        :title="progressTitle"
                        :progress-categories="progressCategories"
                        @scroll-to-top="scrollToTop"
                      />

                      <AssessmentProgressSkeleton v-else />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ModalAddNoteAssessment
              :title="
                getComponentUiText(
                  'app-component-assessment-add-note-modal-title-1',
                )
              "
              :show="showModalAssessment"
              :value="selectQuestion"
              @update:show="showModalAssessment = $event"
            />
          </div>
        </div>
      </div>
    </template>
  </AppBarLayout>
  <Tooltip
    id="profile-tooltip"
    :variant="isToastPositive ? 'success' : 'danger'"
    :show="!!toastMessage"
    @close="toastMessage = ''"
  >
    {{ toastMessage }}
  </Tooltip>
  <ModalImage
    v-if="isModalImgShown"
    class-name="tw-top-0 tw-z-[1072]"
    @close-modal="closeModalImg"
  >
    <img
      :src="urlAttachment"
      style="object-fit: contain; width: 100%; height: 100%"
      @click.stop
    />
  </ModalImage>
  <CreateAndUpdateAssessmentModal
    v-model:show="createAndUpdateAssessmentShow"
    :checklist-id="checklistIdParam"
  />
</template>
<script lang="ts" setup>
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import BrandPattern from "@/components/prospect/brandPattern/brandPattern4.vue";
import BackgroundComponent from "@/components/common/backgroundComponent.vue";
import Tooltip from "@/components/common/tooltip.vue";
import {
  computed,
  ComputedRef,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  reactive,
  Ref,
  ref,
  watch,
} from "vue";
import {
  getComponentUiText,
  countElementsFromTree,
  downloadCSV,
  checkIsHavePermisstion,
} from "@/utils/utilities";
import AssessmentCardWrapper from "@/components/assessments/assessmentCardWrapper.vue";
import { IAssessmentsCardProps } from "@/interfaces/assessments/IAssessmentsCardProps";
import SearchBox from "@/components/assessment/searchBox.vue";
import ModalAddNoteAssessment from "@/components/assessment/modalAddNoteAssessment.vue";
import { IAssessmentQuestion } from "@/interfaces/assessments/IAssessmentQuestion";
import AssessmentCategoryHeader from "@/components/assessment/assessmentCategoryHeader.vue";
import AssessmentViewToggle from "@/components/assessment/assessmentViewToggle.vue";
import { useRoute } from "vue-router";
import {
  deleteChecklist,
  filterChecklistByName,
  getChecklist,
  getChecklistCSV,
  getCheckListDuplicate,
  isValidCompliance,
  isValidScoreIncrease,
  postToggleChecklistItems,
  putChecklistStatus,
} from "@/services/assessment";
import {
  ASSESSMENT_ANSWER_STORE_TYPE,
  assessmentQuestionAnswerType,
  assessmentQuestionVisibleState,
  assessmentStatus,
  assessmentViews,
  checklistStatusId,
  checklistStatusNotes,
  INIT_NUMBER_SHOW_QUESTION,
  localStorageBoolean,
  localStorageKey,
  mainAssessmentFilterDefaul,
  MODAL_NAME,
  NUMBER_LOADMORE_QUESTION,
  SEARCH_TYPE_ID,
  successStatusCodes,
  FILTER_MODAL_TYPE,
  orderChecklistValue,
  CHECKLISTSTATUS,
} from "@/utils/constants";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import AssessmentQuestionSubCategory from "@/components/assessment/assessmentQuestionSubCategory.vue";
import AssessmentProgress from "@/components/assessment/assessmentProgress.vue";
import Button1 from "@/components/common/button1.vue";
import AssessmentQuestionSubCategoryList from "@/components/assessment/assessmentQuestionSubCategoryList.vue";
import store from "@/store";
import {
  IAssessmentChecklistItem,
  IChecklistInfoDetail,
} from "@/interfaces/assessments/IAssessmentDetails";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Assessment, Checklist } from "@/services/apiRoutes/routes";
import AssessmentQuestionSubCategorySkeleton from "@/components/skeleton/assessmentQuestionSubCategorySkeleton.vue";
import router from "@/router";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import FilterModal from "@/components/common/filter/filterModal.vue";
import AssessmentProgressSkeleton from "./../../components/skeleton/assessmentProgressSkeleton.vue";
import ModalImage from "@/components/common/modalComponent.vue";
import popoverAssessment from "@/components/assessment/popoverAssessment.vue";
import CreateAndUpdateAssessmentModal from "@/components/assessment/createAndUpdateAssessmentModal.vue";
import {
  IFilterSelect,
  IFilterTarget,
  IFilterTargetValue,
  IModalMessage,
} from "@/interfaces/common/common";
import dayjs from "dayjs";
import eventEmitter from "@/utils/eventEmitter";
import AssessmentLoadmoreSkeleton from "@/components/skeleton/assessmentLoadmoreSkeleton.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "@/assets/animation/progress_light.json";
import cloneDeep from "lodash/cloneDeep";
import AssessmentCategoryDetail from "@/components/assessment/assessmentCategoryDetail.vue";
import AssessmentCategoryDetailSkeleton from "@/components/skeleton/assessmentCategoryDetailSkeleton.vue";
import { groupFilters } from "@/services/vendor";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";

const route = useRoute();
const toastMessage = ref("");
const view = computed(() => store.getters["Assessment/getAssessmentView"]);
const isToastPositive = ref(true);
const showModalAssessment: Ref<boolean> = ref(false);
const animationRef: Ref<typeof BrandPattern | null> = ref(null);
const clickboxAccessRef: Ref<HTMLElement | null> = ref(null);
const containerRef: Ref<HTMLElement | null> = ref(null);
const checklistIdParam = ref<number>(0);
const valueSearch = ref("");
const progressTitle = ref(
  getComponentUiText("app-component-assessment-progress-header-title-1"),
);
const selectedQuestions: Ref<number[]> = ref([]);
const indexActiveCategory: Ref<number> = ref(0);
const isMounted: Ref<boolean> = ref(false);
const createAndUpdateAssessmentShow = ref(false);
const listQuestionsSelected: Ref<IAssessmentChecklistItem[]> = ref([]);
const isLoadingAnimation: Ref<boolean> = ref(false);

const handleDeleteAssessment = async () => {
  isLoadingAnimation.value = true;
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  await handlePostChecklistStatus(checklistIdParam.value, {
    checklistStatusId: checklistStatusId.defunct,
    checklistStatusNotes: checklistStatusNotes.updateScreen,
  });

  isLoadingAnimation.value = false;
};

const handleUpdateAssessmentDetails = async () => {
  const res = await getChecklist(checklistIdParam.value);
  const checklistAssessmentById = res.data?.data;

  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_UPDATE_ASSESSMENT_DETAIL,
    properties: {
      checklistAssessmentData: {
        ...checklistAssessmentById,
        checklistDescription: checklistAssessmentById?.checklistDescription,
        checklistName: checklistAssessmentById?.checklistName,
      },
    },
    events: {
      "update:data": () => {},
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleDeleteAssessmentPermanently = async () => {
  isLoadingAnimation.value = true;
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  try {
    const res = await deleteChecklist(checklistIdParam.value);
    if (res.status === successStatusCodes.OK) {
      isLoadingAnimation.value = false;
      showSuccessToast(getComponentUiText("app-assessment-toast-delete-1"));
      router.push({ path: "/assess/manage" });
    } else {
      showError(res.data.message);
    }
  } catch (error: any) {
    showError(error.message);
  }
};

const handlePutOnHold = async () => {
  isLoadingAnimation.value = true;
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  await handlePostChecklistStatus(checklistIdParam.value, {
    checklistStatusId: checklistStatusId.paused,
    checklistStatusNotes: checklistStatusNotes.createScreen,
  });
  isLoadingAnimation.value = false;
};

const handleDuplicateAssessment = async () => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_DUPLICATE_ASSESSMENT,
    properties: {
      checklistAssessmentData: {
        ...checklistData.value,
        checklistName: `${checklistData.value
          ?.checklistName} ${getComponentUiText(
          "app-component-assessment-duplicate-assessment-modal-field-suffix-name-1",
        )}`,
        checklistDescription: checklistData.value?.checklistDescription,
      },
      updateDataFucntion: async (payload) => {
        await executeDuplicating(checklistIdParam.value, payload);
      },
    },
    events: {
      "update:data": (payload) =>
        executeDuplicating(checklistIdParam.value, payload),
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const executeDuplicating = async (checklistId, payload) => {
  const res = await getCheckListDuplicate(checklistId, payload);
  if (
    res.data?.data &&
    res.status === successStatusCodes.OK &&
    typeof res.data.data === "object" &&
    "checklistId" in res.data.data
  ) {
    showSuccessToast(
      getComponentUiText(
        "app-component-assessment-duplicate-assessment-success-1",
      ),
      getComponentUiText(
        "app-component-assessment-duplicate-assessment-link-1",
      ),
      `/assess/input?checklistId=${res.data.data.checklistId}`,
      8000,
    );
  }
};

const handleCreateAndUpdateAssessment = () => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  createAndUpdateAssessmentShow.value = true;
};
const statusDetails: ComputedRef<IChecklistInfoDetail> = computed(
  () => store.getters["Assessment/getChecklistInforDetail"],
);
const handleSetToComplete = async () => {
  let checklistId = null;
  await store.dispatch("Assessment/fetchChecklistAssessment");
  const data = store.getters["Assessment/getChecklistAssessment"];
  data.map((e) => {
    if (e.checklistId === checklistIdParam.value) {
      checklistId = e.checklistId;
    } else {
      e.checklistAssessmentHistory.map((element) => {
        if (element.checklistId === checklistIdParam.value && !checklistId) {
          checklistId = e.checklistId;
        }
      });
    }
  });
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_COMPLETE_ASSESSMENT,
    properties: {
      checklistParentId: checklistId ?? 0,
      updateDataFunction: completeAssessment,
    },
    events: {
      "update:data": completeAssessment,
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleTakeOffHold = async () => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  isLoadingAnimation.value = true;
  await handlePostChecklistStatus(checklistIdParam.value, {
    checklistStatusId: checklistStatusId.inProgress,
    checklistStatusNotes: checklistStatusNotes.updateFromPaused,
  });
  isLoadingAnimation.value = false;
};

const completeAssessment = async (value) => {
  const { note, checklistReportingDate } = value;

  const payload: Record<string, any> = {
    checklistStatusId: checklistStatusId.completed,
    checklistStatusNotes: note,
  };

  if (checklistReportingDate) {
    payload.setReportingDate = true;
    payload.checklistReportingDate = checklistReportingDate;
  }

  const res = await handlePostChecklistStatus(checklistIdParam.value, payload);
  if (res) {
    setTimeout(async () => {
      checklistAssessementById.value = await store.dispatch(
        "Assessment/fetchChecklistByChecklistId",
        checklistIdParam.value,
      );
    }, 100);
  }

  return res;
};

const handleDownloadAssessmentCSV = async () => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  isLoadingAnimation.value = true;
  try {
    const res = await getChecklistCSV(queryValue.value);
    downloadCSV(
      res,
      `CyberSystem_Assessment_Export_${dayjs().format("YYYYMMDD_HHmmss")}_${
        checklistData.value.checklistName ?? ""
      }.csv`,
    );
    isLoadingAnimation.value = false;
    showSuccessToast(
      getComponentUiText("app-api-scanning-export-csv-success-1"),
    );
  } catch (error) {
    isLoadingAnimation.value = false;
    showErrorAPI(error, Checklist.getChecklistCSV);
  }
};

const handlePostChecklistStatus = async (checklistId: number, data: any) => {
  try {
    const res = await putChecklistStatus(checklistId, data);
    if (res.data?.data && res.status === successStatusCodes.OK) {
      await store.dispatch("Assessment/updateStatusAssessmentHistory", {
        checklistId: checklistId,
      });
      checklistAssessementById.value = await store.dispatch(
        "Assessment/fetchChecklistByChecklistId",
        checklistIdParam.value,
      );
      getDataDetailCard();
      getDataStatusCard();
      showSuccessToast(getComponentUiText("app-assessment-toast-success-1"));
    } else {
      showError(res.data.message);
    }
    return true;
  } catch (error: any) {
    showError(error.message);
  }
};

const handleUpdateToInprogress = async () => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  isLoadingAnimation.value = true;
  await handlePostChecklistStatus(checklistIdParam.value, {
    checklistStatusId: checklistStatusId.inProgress,
    checklistStatusNotes: checklistStatusNotes.updateFromCompleted,
  });

  isLoadingAnimation.value = false;
};

const getDataStatusCard = async () => {
  await store.dispatch(
    "Assessment/fetchCheckListIdMetricsCompletion",
    checklistIdParam.value,
  );
};

const getDataDetailCard = async () => {
  await store.dispatch(
    "Assessment/fetchInfoDetailByChecklistId",
    checklistIdParam.value,
  );
};

const items = computed(() => [
  {
    id: "assessment-input-settings-item-put-on-hold",
    text: "app-component-dropdown-set-assessment-to-1",
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.ONHOLD,
    statusTagId: CHECKLISTSTATUS.PAUS,
    isShow:
      statusDetails.value.checklistStatusId !== checklistStatusId.completed &&
      statusDetails.value.checklistStatusId !== checklistStatusId.paused &&
      statusDetails.value.checklistStatusId !== checklistStatusId.defunct,
    action: handlePutOnHold,
  },
  {
    id: "assessment-input-settings-item-take-off-hold",
    text: "app-component-dropdown-set-assessment-to-1",
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.INPROG,
    statusTagId: CHECKLISTSTATUS.INPROG,
    isShow: statusDetails.value.checklistStatusId === checklistStatusId.paused,
    action: handleTakeOffHold,
  },
  {
    id: "assessment-input-settings-item-set-to-complete",
    text: "app-component-dropdown-set-assessment-to-1",
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.COMPLETED,
    statusTagId: CHECKLISTSTATUS.DONE,
    isShow:
      statusDetails.value.checklistStatusId !== checklistStatusId.completed &&
      statusDetails.value.checklistStatusId !== checklistStatusId.defunct,
    action: handleSetToComplete,
  },
  {
    id: "assessment-input-settings-item-download-assessment-csv",
    text: "app-component-assessment-detail-dropdown-option-download-assessment-csv-title-1",
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    isShow: true,
    action: handleDownloadAssessmentCSV,
  },
  {
    id: "assessment-input-settings-item-set-to-inprogress",
    text: "app-component-dropdown-set-assessment-to-1",
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.INPROG,
    statusTagId: CHECKLISTSTATUS.INPROG,
    isShow:
      statusDetails.value.checklistStatusId === checklistStatusId.completed ||
      statusDetails.value.checklistStatusId === checklistStatusId.defunct,
    action: handleUpdateToInprogress,
  },
  {
    id: "assessment-input-settings-item-duplicate-assessment",
    text: "app-component-assessment-title-duplicate-1",
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    isShow:
      statusDetails.value.checklistStatusId !== checklistStatusId.completed &&
      statusDetails.value.checklistStatusId !== checklistStatusId.defunct,
    action: handleDuplicateAssessment,
  },
  {
    id: "assessment-input-settings-item-create-or-update-assessment-template",
    text: "app-assess-assessment-history-create-or-update-assessment-template-1",
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    isShow: true,
    action: handleCreateAndUpdateAssessment,
  },
  {
    id: "assessment-input-settings-item-assessment-detail",
    text: "app-component-assessment-update-assessment-detail-modal-title-1",
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    isShow:
      statusDetails.value.checklistStatusId !== checklistStatusId.completed &&
      statusDetails.value.checklistStatusId !== checklistStatusId.defunct,
    action: handleUpdateAssessmentDetails,
  },
  {
    id: "assessment-input-settings-item-duplicate-assessment",
    text: "app-component-assessment-title-duplicate-1",
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    isShow:
      statusDetails.value.checklistStatusId === checklistStatusId.completed ||
      statusDetails.value.checklistStatusId === checklistStatusId.defunct,
    action: handleDuplicateAssessment,
  },
  {
    id: "assessment-input-settings-item-delete-assessment",
    text: "app-assess-assessment-history-delete-assessment-1",
    arrowRed: true,
    statusTag: "",
    statusTagId: "",
    isShow:
      statusDetails.value.checklistStatusId !== checklistStatusId.completed &&
      statusDetails.value.checklistStatusId !== checklistStatusId.defunct,
    action: handleDeleteAssessment,
  },

  {
    id: "assessment-input-settings-item-permanently-delete-assessment",
    text: "app-assess-assessment-history-permanently-delete-assessment-1",
    arrowRed: true,
    statusTag: "",
    statusTagId: "",
    isShow: statusDetails.value.checklistStatusId === checklistStatusId.defunct,
    action: handleDeleteAssessmentPermanently,
  },
]);
const categoryLoading = ref(false);

const urlAttachment = ref("");
const isModalImgShown = ref(false);
const isLoadingQuestion: any = ref(null);
// Fetch data
onBeforeMount(() => {
  (async () => {
    await store.dispatch("Assessment/resetChecklist");
    await store.dispatch("Assessment/fetchAssessmentQuestionTypes");
    await handleActiveCategory();
  })();
});

const queryValue = computed(() => Number(route.query.checklistId));

onBeforeUnmount(() => {
  store.dispatch("Assessment/resetAssessment");
});

const checklistAssessementById = ref<any>(null);

onMounted(async () => {
  isHavePermisstionShowMaster.value = await checkIsHavePermisstion(
    "assess_input__show_master_items",
  );
  checklistIdParam.value = queryValue.value;
  const mainAssessmentFilterId = localStorage.getItem(
    localStorageKey.mainAssessmentFilterId,
  );
  if (
    mainAssessmentFilterId &&
    mainAssessmentFilterId === `${checklistIdParam.value}`
  ) {
    const originSelected = JSON.parse(
      localStorage.getItem(localStorageKey.mainAssessmentFilter) ||
        JSON.stringify(mainAssessmentFilterDefaul),
    );
    store.dispatch("Assessment/setFilters", originSelected);
  } else {
    localStorage.removeItem(localStorageKey.mainAssessmentFilter);
    localStorage.removeItem(localStorageKey.mainAssessmentFilterId);
  }
  if (!checklistIdParam.value) {
    router.push({
      path: "/assess/manage",
    });
    return;
  }
  store.dispatch(
    "Assessment/fetchCheckListIdMetricsCompletion",
    queryValue.value,
  );
  store.dispatch("Assessment/fetchInfoDetailByChecklistId", queryValue.value);
  store.dispatch("Assessment/updateChecklistId", queryValue.value);
  store.dispatch("Assessment/fetchImportanceAssessment");
  store.dispatch("Assessment/fetchImpactAssessment");
  store.dispatch("Assessment/fetchEffortAssessment");
  store.dispatch("Assessment/fetchCostAssessment");
  store.dispatch("Assessment/fetchSuggestedActionData");
  store.dispatch("Assessment/getRecentSearches", {
    searchTypeId: SEARCH_TYPE_ID.CL_INPUT,
  });
  checklistAssessementById.value = await store.dispatch(
    "Assessment/fetchChecklistByChecklistId",
    checklistIdParam.value,
  );

  window.addEventListener("click", (e: any) => {
    if (!clickboxAccessRef.value?.contains(e.target)) {
      animationRef.value && animationRef.value?.reloadToggle();
    }
  });

  if (checklistIdParam.value) initial();
  isMounted.value = true;
  listenOpenImageModal();

  const storedValueSearch = localStorage.getItem(
    localStorageKey.assessmentSearchTerm,
  );
  if (storedValueSearch) {
    valueSearch.value = storedValueSearch;
    eventEmitter.emit(EmitterEvents.VALUE_SEARCH, storedValueSearch);
    localStorage.removeItem(localStorageKey.assessmentSearchTerm);
  }
});

watch(
  () => queryValue.value,
  async (newVal) => {
    isMounted.value = false;
    checklistIdParam.value = newVal;
    store.dispatch("Assessment/resetChecklist");
    store.dispatch("Assessment/fetchAssessmentQuestionTypes");
    handleActiveCategory();
    store.commit("Assessment/CLEAR_ASSESSMENT_INPUT");
    store.dispatch("Assessment/fetchCheckListIdMetricsCompletion", newVal);
    store.dispatch("Assessment/fetchInfoDetailByChecklistId", newVal);
    store.dispatch("Assessment/updateChecklistId", newVal);
    store.dispatch("Assessment/fetchImportanceAssessment");
    store.dispatch("Assessment/fetchImpactAssessment");
    store.dispatch("Assessment/fetchEffortAssessment");
    store.dispatch("Assessment/fetchCostAssessment");
    store.dispatch("Assessment/fetchSuggestedActionData");

    window.addEventListener("click", (e: any) => {
      if (!clickboxAccessRef.value?.contains(e.target)) {
        animationRef.value && animationRef.value?.reloadToggle();
      }
    });

    if (newVal) initial();
    isMounted.value = true;
    listenOpenImageModal();
  },
);

// When progressCategories have data => Get Checklist.
const progressCategories = computed(() => store.state.Assessment.categories);
const activeCategories = computed(() => store.state.Assessment.activeCategory);
const refreshCategories = computed(
  () => store.state.Assessment.reFreshCategory,
);
const currentOrg = computed(() => store.state.Org.currentOrg);

watch(
  () => currentOrg.value,
  (newOrg, oldOrg) => {
    if (
      newOrg &&
      newOrg.orgId &&
      oldOrg &&
      oldOrg.orgId &&
      newOrg.orgId !== oldOrg.orgId
    ) {
      router.push({
        path: "/assess/manage",
      });
    }
  },
);

// array of tree with children
const listQuestion: ComputedRef<IAssessmentChecklistItem[]> = computed(
  () => store.getters["Assessment/getChecklistActive"],
);

const checklistData = computed(
  () => store.getters["Assessment/getChecklistDetail"],
);
const searchListQuestion: Ref<any> = ref([]);

const countLeaf = (tree) => {
  let count = 0;

  tree.forEach((node) => {
    if (
      (!node.checklistChildren || node.checklistChildren.length === 0) &&
      (node.checklistItemComplianceTypeValue ||
        node.checklistItemComplianceTypeValue === 0 ||
        node.checklistItemCompensatingControlValue ||
        node.checklistItemComplianceOverride)
    ) {
      count += 1;
    }
    if (node.checklistChildren && node.checklistChildren.length > 0) {
      count += countLeaf(node.checklistChildren);
    }
  });

  return count;
};

watch(
  () => selectedQuestions.value,
  (next, prev) => {
    const arrPrune = prev.filter((id) => !next.includes(id));
    const arrAdd = next.filter((id) => !prev.includes(id));
    const oldData = listQuestionsSelected.value.filter(
      (item) => !arrPrune.includes(item.checklistItemId),
    );
    const loopChild = (parent: any) => {
      const output: any[] = [];
      if (parent.checklistChildren?.length) {
        (parent.checklistChildren || []).forEach((child: any) => {
          output.push(...loopChild(child));
        });
      } else {
        output.push(parent);
      }
      return output;
    };
    const arrChild: any = [];
    listQuestion.value.forEach((parent: any) => {
      arrChild.push(...loopChild(parent));
    });

    const newData = arrChild.filter((item) =>
      arrAdd.includes(item.checklistItemId),
    );
    listQuestionsSelected.value = [...oldData, ...newData].sort(
      (a, b) => a.checklistItemOrder - b.checklistItemOrder,
    );
  },
);

const initial = async () => {
  await getCategories(checklistIdParam.value);
  await getAssessmentMetric(checklistIdParam.value);
  await checkListIdMetricsCountCompliance(checklistIdParam.value);
  getChecklistAll();
};

const checkListIdMetricsCountCompliance = async (checklistId) => {
  try {
    const res = await store.dispatch(
      "Assessment/getCheckListIdMetricsCountCompliance",
      String(checklistId),
    );
    if (res?.data?.data && res.status === successStatusCodes.OK) {
      sampleCardData.exposuresCard.criticalNumber =
        res.data.data.checklistItemsComplianceLt || 0;
      sampleCardData.exposuresCard.totalNumber =
        res.data.data.checklistItemsComplianceLt || 0;
    } else {
      showError(res.data.message);
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Assessment.checkListIdMetricsCountCompliance);
    }
  }
};

const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const sampleCardData: IAssessmentsCardProps = reactive({
  detailsCard: {
    id: 1,
    createdTime: "2023-9-9",
    updatedTime: "2023-7-17 12:40:00",
    status: assessmentStatus.notStarted,
  },
  exposuresCard: {
    criticalNumber: 0,
    totalNumber: 0,
  },
  completionCard: {
    percent: 0,
  },
  contributorsCard: {
    checklistId: checklistIdParam.value,
  },
});
const hideComplete: any = computed(
  () =>
    originSelected.value.find((item) => item.targetId === "itemCompleteValue")
      ?.value,
);
const isMasterItems: Ref<boolean> = computed(
  () => store.getters["Assessment/getShowMasterItems"],
);
const selectQuestion: IAssessmentQuestion = {
  title: getComponentUiText("app-component-assessment-add-note-modal-title-1"),
  questionNumber: "1.2",
  questionTitle: getComponentUiText(
    "app-component-assessments-checklists-assesssment-category-question-title-1",
  ),
  category: getComponentUiText(
    "app-component-assessments-checklists-assesssment-category-1",
  ),
  subCategory: getComponentUiText(
    "app-component-assessments-checklists-assesssment-sub-category-1",
  ),
  note: "",
  percent: 0,
  compensatingOverrideScore: 0,
  complianceOverrideScore: 0,
  checklistId: 0,
  checklistItemId: 0,
};

const currentValue = (_value) => (valueSearch.value = _value);

const lastScrollTop = ref(0);
const isLoadingNewData = ref(false);
const timeout = ref();
const searchShowNumber = ref(INIT_NUMBER_SHOW_QUESTION);

const updateView = (value: string) => {
  if (value === assessmentViews.list) {
    isLoadingNewData.value = true;
    searchShowNumber.value = 0;
    setTimeout(() => {
      searchShowNumber.value = INIT_NUMBER_SHOW_QUESTION;
      isLoadingNewData.value = false;
    }, 10);
  } else {
    searchShowNumber.value = INIT_NUMBER_SHOW_QUESTION;
  }
};

const onScroll = (event: any) => {
  const isScrollDown = event.target.scrollTop > lastScrollTop.value;
  const isScrollToBottom =
    isScrollDown &&
    event.target.scrollHeight - event.target.scrollTop <=
      event.target.clientHeight + 100;

  lastScrollTop.value = event.target.scrollTop;
  if (
    isScrollToBottom &&
    countElementsFromTree(listQuestion.value) > searchShowNumber.value &&
    !isLoadingQuestion.value
  ) {
    isLoadingNewData.value = true;
    clearTimeout(timeout.value);
    timeout.value = setTimeout(() => {
      if (
        searchShowNumber.value + NUMBER_LOADMORE_QUESTION >
        countElementsFromTree(listQuestion.value)
      ) {
        searchShowNumber.value = countElementsFromTree(listQuestion.value);
      } else {
        searchShowNumber.value += NUMBER_LOADMORE_QUESTION;
      }
      isLoadingNewData.value = false;
    }, 100); // timeout for show loading
  }
};
const recursiveFilter = (array) => {
  let result: any[] = [];
  let newArray: any[] = [];
  try {
    for (const item of array) {
      if (countElementsFromTree(newArray) >= searchShowNumber.value) break;
      if (!item.checklistChildren || item.checklistChildren.length === 0) {
        if (!item.isMaster || (item.isMaster && !item.itemMasterIsHeading)) {
          if (Object.keys(filterSelected.value).length) {
            if (checkIsQuestionValid(item)) {
              result.push({ ...item });
              newArray.push({ ...item });
            }
          } else {
            result.push({ ...item });
            newArray.push({ ...item });
          }
        }
      } else {
        const filteredChildren: any = recursiveFilter(item.checklistChildren);
        const orderNumber = getOrderNumber(item.checklistChildren);
        if (
          filteredChildren.length > 0 ||
          (item.checklistItemIsHeading &&
            !originSelected.value.some(
              (o) =>
                o.targetId !== "itemCompleteValue" &&
                o.targetId !== "visibleState" &&
                o.targetId !== "isMaster",
            ) &&
            originSelected.value.some(
              (o) => o.targetId === "itemCompleteValue" && o.value.id === 0,
            ))
        ) {
          newArray.push({
            ...item,
            checklistChildren: [...filteredChildren],
            orderNumber,
          });
        }
      }
    }
    return newArray;
  } catch (error) {
    return [];
  }
};

const checkIsQuestionValid = (item: any) => {
  return (
    item.checklistItemIsHeading ||
    Object.entries(filterSelected.value).every(([targetId, value]) => {
      if (targetId === "itemCompleteValue-percentage") {
        return isValidCompliance(item, value);
      }

      if (targetId === "score-increase") {
        return isValidScoreIncrease(item, value);
      }

      return (
        (value.has(item[targetId]) &&
          targetId !== "itemCompleteValue" &&
          targetId !== "visibleState" &&
          targetId !== "isMaster") ||
        (targetId === "itemCompleteValue" &&
          (value.has(1) ||
            (value.has(0) && item.itemCompleteValue === undefined))) ||
        (targetId === "visibleState" &&
          (value.has(1) ||
            (value.has(0) &&
              item.visibleState !== assessmentQuestionVisibleState.no) ||
            item.isMaster)) ||
        (targetId === "isMaster" &&
          (value.has(1) || (value.has(0) && !item.isMaster)))
      );
    })
  );
};

const getOrderNumber = (items) => {
  const item = items.find((i) => i.orderNumber !== "" && i.orderNumber);
  return item
    ? item.orderNumber.substring(0, item.orderNumber.lastIndexOf("."))
    : "";
};

const getAssessmentQuestionShow = computed(() => {
  // filter by search box
  const filterBySearch = filterChecklistByName(
    cloneDeep(listQuestion.value) || [],
    valueSearch.value,
    true,
  );
  const filteredArray = recursiveFilter(filterBySearch);
  return filteredArray;
});

const currentQuestions = ref(getAssessmentQuestionShow.value);

watch(
  () => getAssessmentQuestionShow.value,
  (newVal) => {
    const checklistUpdateType =
      store.getters["Assessment/getChecklistUpdateType"];
    if (
      checklistUpdateType ===
        ASSESSMENT_ANSWER_STORE_TYPE.CHECKLIST_ITEM_IMPORTANCE ||
      checklistUpdateType ===
        ASSESSMENT_ANSWER_STORE_TYPE.COMPLIANCE_OVERRIDE ||
      checklistUpdateType === ASSESSMENT_ANSWER_STORE_TYPE.COMPLIANCE_TYPE_VALUE
    ) {
      setTimeout(() => {
        currentQuestions.value = newVal;
        store.dispatch("Assessment/resetChecklistUpdateType");
      }, 1000);
    } else currentQuestions.value = newVal;
  },
);

const getAssessmentMetric = async (checklistId: number) => {
  try {
    await store.dispatch(
      "Assessment/getChecklistMetricScoreCompletion",
      checklistId,
    );
  } catch (error: any) {
    showErrorAPI(error, Checklist.getChecklistToItemMetric);
  }
};

const getCategories = async (checklistId: number) => {
  const reload = route.query?.reload;
  categoryLoading.value = true;
  await store.dispatch("Assessment/fetchCategories", {
    checklistId,
    reload: !(reload === localStorageBoolean.true),
  });
  categoryLoading.value = false;
};

const getChecklistAll = async () => {
  // Fetch org setup if not exist.
  const originSetup =
    store.state.SetupWizard.questions[currentOrg.value.id] || null;
  if (!originSetup) {
    store.dispatch("SetupWizard/fetchQuestion");
  }
  const queryValue = Number(route.query.checklistId);
  store.dispatch("Assessment/fetchChecklistAll", queryValue);
};

const getIndexActiveCategory = () => {
  return progressCategories.value.findIndex(
    (c) => c.checklistItemCategoryId === activeCategories.value,
  );
};

const handleActiveCategory = async (isForceUpdate = false) => {
  isShowFilterAction.value = false;
  isLoadingQuestion.value = true;
  try {
    const index = getIndexActiveCategory();
    if (index === -1) return;
    indexActiveCategory.value = index;
    searchShowNumber.value = INIT_NUMBER_SHOW_QUESTION;
    selectedQuestions.value = [];
    listQuestionsSelected.value = [];
    const params = {
      checklistIdParam: checklistIdParam.value,
      showMasterItem: true,
      isForceUpdate,
    };
    // showMasterItem: isMasterItems.value,

    await store.dispatch("Assessment/fetchChecklistByCategory", params);
    isLoadingQuestion.value = false;
  } catch (error) {
    isLoadingQuestion.value = false;
    console.error(error);
  } finally {
    store.dispatch("Assessment/changeRefreshCategory", false);
  }
};

const changeActiveCategory = (isNext = true) => {
  let newIndex = 0;
  const index = getIndexActiveCategory();

  if (index === -1) return;
  if (isNext && index >= progressCategories.value.length - 1) return;
  if (!isNext && index === 0) return;

  newIndex = isNext ? index + 1 : index - 1;
  const newActiveCategory =
    progressCategories.value[newIndex].checklistItemCategoryId;

  localStorage.setItem(
    localStorageKey.assessmentActiveCategory,
    newActiveCategory,
  );
  store.dispatch("Assessment/changeActiveCategory", newActiveCategory);
  scrollToTop();
};

const isFlashing = ref(false);

const scrollToTop = () => {
  containerRef.value &&
    containerRef.value.scrollTo({
      top: 0,
    });

  setTimeout(() => {
    isFlashing.value = true;
    setTimeout(() => {
      isFlashing.value = false;
    }, 100);
  }, 100);
};

const handleUpdateSearchListQuestion = () => {
  const totalSearch = countElementsFromTree(searchListQuestion.value);

  if (countElementsFromTree(listQuestion.value) !== totalSearch) {
    searchShowNumber.value = INIT_NUMBER_SHOW_QUESTION;
  }
};

const toggleCheckListItem = async (
  checklistItemId: number,
  checklistId: number,
  item: any,
) => {
  try {
    await postToggleChecklistItems(checklistIdParam.value, [checklistItemId]);
    await store.dispatch("Assessment/updateCheckListItems", {
      checklistId,
      checklistItemIds: [checklistItemId],
      type: ASSESSMENT_ANSWER_STORE_TYPE.EXCLUDE_ITEM,
    });
  } catch (error: any) {
    showErrorAPI(error, Checklist.toggleChecklistToItem);
  }
};

const updateOrderNumber = () => {
  let orderNumberCount = 0;
  listQuestion.value.forEach((item, index) => {
    item.checklistChildren?.forEach((i) => {
      if (!i.isMaster) {
        orderNumberCount = orderNumberCount + 1;
        i.orderNumber = `${index + 1}.${orderNumberCount}`;
      } else {
        i.orderNumber = "";
      }
    });
    orderNumberCount = 0;
  });
};

//#region Filter
const isHavePermisstionShowMaster: Ref<boolean | undefined> = ref(false);
const fiterTargetOption: Ref<IFilterTarget[]> = ref([]);
const outsideFilterModal = ref(false);

const filterSelected = ref(
  localStorage.getItem(localStorageKey.mainAssessmentFilter) &&
    localStorage.getItem(localStorageKey.mainAssessmentFilterId) ==
      route.query.checklistId
    ? groupFilters(
        JSON.parse(
          localStorage.getItem(localStorageKey.mainAssessmentFilter) || "{}",
        ) || [],
      )
    : [],
);

const clearFilter = () => {
  originSelected.value = cloneDeep(mainAssessmentFilterDefaul);
  filterSelected.value = groupFilters(originSelected.value);
  localStorage.removeItem(localStorageKey.mainAssessmentFilter);
  localStorage.removeItem(localStorageKey.mainAssessmentFilterId);
};

watch(
  () => fiterTargetOption.value,
  (newVal) => {
    if (fiterTargetOption.value.length === 0) {
      return;
    }
    // if has target visibleState and has not selected, set to default
    if (
      !originSelected.value.find((item) => item.targetId === "visibleState") &&
      fiterTargetOption.value.find(
        (target) => target.targetId === "visibleState",
      )
    ) {
      originSelected.value.push({
        targetId: "visibleState",
        value: {
          id: 0,
          text: getComponentUiText(
            "app-component-assessment-display-options-filter-show-excluded-option-A-1",
          ),
          isDefault: true,
          isHardText: true,
        },
      });
    }
    // if has target isMaster and has not selected, set to default
    if (
      !originSelected.value.find((item) => item.targetId === "isMaster") &&
      fiterTargetOption.value.find((target) => target.targetId === "isMaster")
    ) {
      originSelected.value.push({
        targetId: "isMaster",
        value: {
          id: 0,
          text: getComponentUiText(
            "app-component-assessment-display-options-filter-show-master-items-option-A-1",
          ),
          isDefault: true,
          isHardText: true,
        },
      });
    }
    // if has target itemCompleteValue and has not selected, set to default
    if (
      !originSelected.value.find(
        (item) => item.targetId === "itemCompleteValue",
      ) &&
      fiterTargetOption.value.find(
        (target) => target.targetId === "itemCompleteValue",
      )
    ) {
      originSelected.value.push({
        targetId: "itemCompleteValue",
        value: {
          id: 1,
          isDefault: true,
          text: getComponentUiText(
            "app-component-assessment-display-options-filter-hide-complete-option-B-1",
          ),
          isHardText: true,
        },
      });
    }
    if (originSelected.value.length === 0) {
      originSelected.value = mainAssessmentFilterDefaul;
    }
    filterSelected.value = groupFilters(originSelected.value);
  },
  { deep: true },
);

const originSelected: Ref<IFilterSelect[]> = ref(
  localStorage.getItem(localStorageKey.mainAssessmentFilter) &&
    localStorage.getItem(localStorageKey.mainAssessmentFilterId) ==
      route.query.checklistId
    ? JSON.parse(
        localStorage.getItem(localStorageKey.mainAssessmentFilter) || "{}",
      ) || []
    : [],
);

watch(
  () => listQuestion.value,
  (newVal) => {
    if (newVal.length > 0) {
      getFilterTarget(flattenAray(newVal));
    } else {
      fiterTargetOption.value = [];
    }
  },
  { deep: true },
);

const flattenAray = (array) => {
  let result: any[] = [];
  array.forEach((item) => {
    if (item.checklistChildren && item.checklistChildren.length > 0) {
      result = result.concat(flattenAray(item.checklistChildren));
    } else {
      result.push(item);
    }
  });
  return result;
};
const assessmentQuestionTypes = computed(
  () => store.getters["Assessment/getAssessmentQuestionTypes"],
);

const getFilterTarget = async (listQuestion) => {
  fiterTargetOption.value = [];
  let completedsTypes: IFilterTargetValue[] = [],
    excludeTypes: IFilterTargetValue[] = [],
    masterItemTypes: IFilterTargetValue[] = [],
    costTypes: IFilterTargetValue[] = [],
    effortTypes: IFilterTargetValue[] = [],
    impactTypes: IFilterTargetValue[] = [],
    importances: IFilterTargetValue[] = [],
    questionTypes: IFilterTargetValue[] = [];
  for (let i = 0; i < listQuestion.length; i++) {
    const item = listQuestion[i];
    if (item.isMaster && item.itemMasterIsHeading) {
      continue;
    }
    const questionLabel = assessmentQuestionTypes.value.find(
      (e) => e.id === item.checklistItemComplianceTypeId,
    );
    if (!questionLabel) continue;

    // completed type
    if (completedsTypes.length === 0 && item.itemCompleteValue !== undefined) {
      completedsTypes = [
        {
          id: 0,
          text: getComponentUiText(
            "app-component-assessment-display-options-filter-hide-complete-option-A-1",
          ),
          isHardText: true,
        },
        {
          id: 1,
          isDefault: true,
          text: getComponentUiText(
            "app-component-assessment-display-options-filter-hide-complete-option-B-1",
          ),
          isHardText: true,
        },
      ];
      fiterTargetOption.value.push({
        targetId: "itemCompleteValue",
        order: 1,
        targetText:
          "app-component-assessment-display-options-filter-hide-complete-1",
        values: completedsTypes,
        isRadio: true,
      });
    }

    // exclude type
    if (
      excludeTypes.length === 0 &&
      item.visibleState === assessmentQuestionVisibleState.no &&
      !item.isMaster
    ) {
      excludeTypes = [
        {
          id: 0,
          text: getComponentUiText(
            "app-component-assessment-display-options-filter-show-excluded-option-A-1",
          ),
          isDefault: true,
          isHardText: true,
        },
        {
          id: 1,
          text: getComponentUiText(
            "app-component-assessment-display-options-filter-show-excluded-option-B-1",
          ),
          isHardText: true,
        },
      ];
      fiterTargetOption.value.push({
        targetId: "visibleState",
        order: 2,
        targetText:
          "app-component-assessment-display-options-filter-show-excluded-1",
        values: excludeTypes,
        isRadio: true,
      });
    }

    // master item type
    if (
      masterItemTypes.length === 0 &&
      item.isMaster &&
      isHavePermisstionShowMaster.value
    ) {
      masterItemTypes = [
        {
          id: 0,
          text: getComponentUiText(
            "app-component-assessment-display-options-filter-show-master-items-option-A-1",
          ),
          isDefault: true,
          isHardText: true,
        },
        {
          id: 1,
          text: getComponentUiText(
            "app-component-assessment-display-options-filter-show-master-items-option-B-1",
          ),
          isHardText: true,
        },
      ];
      fiterTargetOption.value.push({
        targetId: "isMaster",
        order: 3,
        targetText:
          "app-component-assessment-display-options-filter-show-master-items-1",
        values: masterItemTypes,
        isRadio: true,
      });
    }

    // costTypes
    if (
      (costTypes.length === 0 ||
        !costTypes.find((e) => e.id === `${item.checklistItemCostId}`)) &&
      item.checklistItemCostId !== null &&
      item.checklistItemCostId !== undefined
    ) {
      const costType = {
        id: `${item.checklistItemCostId}`,
        text: getComponentUiText(
          `app-component-assessment-display-options-filter-importance-option-${item.checklistItemCostId}-1`,
        ),
        isHardText: true,
        order: orderChecklistValue[item.checklistItemCostId],
      };
      costTypes.push(costType);
      const costIndex = fiterTargetOption.value.findIndex(
        (e) => e.targetId === "checklistItemCostId",
      );
      if (costIndex === -1) {
        fiterTargetOption.value.push({
          targetId: "checklistItemCostId",
          order: 6,
          targetText:
            "app-component-assessment-display-options-filter-importance-option-cost-1",
          values: [costType],
        });
      } else {
        fiterTargetOption.value[costIndex].values.push(costType);
        fiterTargetOption.value[costIndex].values = fiterTargetOption.value[
          costIndex
        ].values.sort((a, b) => a.order - b.order);
      }
    }

    // effortTypes - zero
    if (
      (effortTypes.length === 0 ||
        !effortTypes.find((e) => e.id === `${item.checklistItemEffortId}`)) &&
      item.checklistItemEffortId !== null &&
      item.checklistItemEffortId !== undefined
    ) {
      const effortType = {
        id: `${item.checklistItemEffortId}`,
        text: getComponentUiText(
          `app-component-assessment-display-options-filter-importance-option-${item.checklistItemEffortId}-1`,
        ),
        order: orderChecklistValue[item.checklistItemEffortId],
        isHardText: true,
      };
      effortTypes.push(effortType);
      const effIndex = fiterTargetOption.value.findIndex(
        (e) => e.targetId === "checklistItemEffortId",
      );
      if (effIndex === -1) {
        fiterTargetOption.value.push({
          targetId: "checklistItemEffortId",
          order: 7,
          targetText:
            "app-component-assessment-display-options-filter-importance-option-effort-1",
          values: [effortType],
        });
      } else {
        fiterTargetOption.value[effIndex].values.push(effortType);
        fiterTargetOption.value[effIndex].values = fiterTargetOption.value[
          effIndex
        ].values.sort((a, b) => a.order - b.order);
      }
    }

    // ImpactTypes
    if (
      (impactTypes.length === 0 ||
        !impactTypes.find((e) => e.id === `${item.checklistItemImpactId}`)) &&
      item.checklistItemImpactId !== null &&
      item.checklistItemImpactId !== undefined
    ) {
      const impactType = {
        id: `${item.checklistItemImpactId}`,
        text: getComponentUiText(
          `app-component-assessment-display-options-filter-importance-option-${item.checklistItemImpactId}-1`,
        ),
        order: orderChecklistValue[item.checklistItemImpactId],
        isHardText: true,
      };
      impactTypes.push(impactType);
      const impactIndex = fiterTargetOption.value.findIndex(
        (e) => e.targetId === "checklistItemImpactId",
      );
      if (impactIndex === -1) {
        fiterTargetOption.value.push({
          targetId: "checklistItemImpactId",
          order: 8,
          targetText:
            "app-component-assessment-display-options-filter-importance-option-impact-1",
          values: [impactType],
        });
      } else {
        fiterTargetOption.value[impactIndex].values.push(impactType);
        fiterTargetOption.value[impactIndex].values = fiterTargetOption.value[
          impactIndex
        ].values.sort((a, b) => a.order - b.order);
      }
    }

    // ImportanceTypes
    if (
      (importances.length === 0 ||
        !importances.find(
          (e) => e.id === `${item.checklistItemImportanceId}`,
        )) &&
      item.checklistItemImportanceId !== null &&
      item.checklistItemImportanceId !== undefined
    ) {
      const importancetype = {
        id: `${item.checklistItemImportanceId}`,
        text: getComponentUiText(
          `app-component-assessment-display-options-filter-importance-option-${item.checklistItemImportanceId}-1`,
        ),
        isHardText: true,
        order: orderChecklistValue[item.checklistItemImportanceId],
      };
      importances.push(importancetype);
      const importanceIndex = fiterTargetOption.value.findIndex(
        (e) => e.targetId === "checklistItemImportanceId",
      );
      if (importanceIndex === -1) {
        fiterTargetOption.value.push({
          targetId: "checklistItemImportanceId",
          order: 5,
          targetText:
            "app-component-assessment-display-options-filter-importance-1",
          values: [importancetype],
        });
      } else {
        fiterTargetOption.value[importanceIndex].values.push(importancetype);
        fiterTargetOption.value[importanceIndex].values =
          fiterTargetOption.value[importanceIndex].values.sort(
            (a, b) => a.order - b.order,
          );
      }
    }

    // questionTypes
    if (
      questionTypes.length === 0 ||
      !questionTypes.find((e) => e.id === item.checklistItemComplianceTypeId)
    ) {
      const questionTypeOption = {
        id: item.checklistItemComplianceTypeId,
        text: questionLabel.label,
        isHardText: true,
      };
      if (questionTypes.length === 0) {
        fiterTargetOption.value.push({
          targetId: "checklistItemComplianceTypeId",
          order: 4,
          targetText:
            "app-component-assessment-display-options-filter-question-type-1",
          values: [questionTypeOption],
        });
      } else {
        const questionTypesIndex = fiterTargetOption.value.findIndex(
          (e) => e.targetId === "checklistItemComplianceTypeId",
        );
        fiterTargetOption.value[questionTypesIndex].values.push(
          questionTypeOption,
        );
      }
      questionTypes.push(questionTypeOption);
    }
  }

  fiterTargetOption.value.push({
    targetId: "score-increase",
    order: 4,
    targetText:
      "app-component-assessment-display-options-filter-score-increase-1",
    values: [
      {
        id: 1,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-compliance-percentage-option-above-1",
        ),
        isHardText: true,
        type: "input",
        hindText: "",
      },
      {
        id: 0,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-compliance-percentage-option-below-1",
        ),
        isHardText: true,
        type: "input",
        hindText: "",
      },
    ],
    isRadio: false,
    isNotClear: true,
  });

  fiterTargetOption.value.push({
    targetId: "itemCompleteValue-percentage",
    order: 4,
    targetText:
      "app-component-assessment-display-options-filter-compliance-percentage-1",
    values: [
      {
        id: 1,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-compliance-percentage-option-above-1",
        ),
        isHardText: true,
        type: "input",
        hindText: "%",
      },
      {
        id: 0,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-compliance-percentage-option-below-1",
        ),
        isHardText: true,
        type: "input",
        hindText: "%",
      },
    ],
    isRadio: false,
    isNotClear: true,
  });
};

const isShowFilterAction = ref(false);
const handleShowFilterAction = () => {
  if (isShowFilterAction.value) {
    outsideFilterModal.value = true;
  } else {
    isShowFilterAction.value = !isShowFilterAction.value;
  }
};

watch(
  () => originSelected.value,
  (newVal) => {
    store.dispatch("Assessment/setFilters", originSelected.value);
  },
  { deep: true },
);

const handleApplyFilter = (data: any) => {
  outsideFilterModal.value = false;
  isShowFilterAction.value = false;
  originSelected.value = data.filterSelecteds;
  localStorage.setItem(
    localStorageKey.mainAssessmentFilter,
    JSON.stringify(data.filterSelecteds),
  );
  localStorage.setItem(
    localStorageKey.mainAssessmentFilterId,
    route.query?.checklistId || "",
  );
  filterSelected.value = groupFilters(data.filterSelecteds);
};

//#endregion Filter

const closeModalImg = () => {
  isModalImgShown.value = false;
};

const listenOpenImageModal = () => {
  EventEmitter.on(EmitterEvents.OPEN_IMAGE_MODAL, (item: any) => {
    urlAttachment.value = item.urlAttachment;
    isModalImgShown.value = true;
  });
};
watch(activeCategories, () => handleActiveCategory());
watch(refreshCategories, (value) => {
  if (value) handleActiveCategory(true);
});
watch(searchListQuestion, handleUpdateSearchListQuestion);
watch(listQuestion, updateOrderNumber);
</script>

<style scoped lang="scss">
.main {
  background: rgba(239, 240, 241, 0.5);
}

.border_bottom {
  border-bottom: 1px solid #eff0f1;
}

.title {
  color: #211f58;
  font-size: 22px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
}

.subTitle {
  color: #211f58;
  font-size: 22px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
}

.assessment-container {
  @media (min-width: 1536px) {
    width: fit-content;
    max-width: 80vw;
    position: relative;
    padding-bottom: 22px;
  }

  .custom-info {
    margin-top: 25px;
  }
}

.assessment-container {
  .title {
    font-size: 22px;
    line-height: 100%;
    color: #211f58;
  }

  .subTitle {
    font-size: 22px;
    line-height: 100%;
    color: #211f58;
  }

  .sub-title {
    color: #211f58;
  }

  .content {
    display: flex;

    @media (max-width: 1536px) {
      flex-flow: column-reverse;
    }

    .table-content {
      min-width: 1060px;

      @media (max-width: 1536px) {
        min-width: 100%;
      }
    }
  }

  .is-disable {
    background: var(--ui-light-grey-50, #dbdbdb);
    color: #b7b7b7 !important;
  }

  .previous-button {
    box-shadow: none;
    background: #ffffff;
    color: #387dff !important;

    &.disabled {
      background: var(--ui-light-grey-50, #dbdbdb);
      color: #b7b7b7 !important;
    }
  }

  .next-button {
    box-shadow: none;

    &.disabled {
      background: var(--ui-light-grey-50, #dbdbdb);
      color: #b7b7b7 !important;
    }
  }
}

@media screen and (max-width: 1500px) {
  .main-body {
    gap: 20px;
  }

  .container-content {
    flex-wrap: wrap-reverse;
    gap: 20px;
  }

  .category-block {
    justify-content: flex-end;
    flex-direction: row-reverse;
  }
  .progressBlock {
    padding-top: 0px;
  }
}

@media screen and (max-width: 496px) {
  .category-block {
    justify-content: center;
    flex-direction: column;
  }
}

.assessment-input-popover-item-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Poppins;
  line-height: 135%;
  cursor: pointer;
  font-weight: normal;
  font-size: 13px;
  padding-left: 13px;
  padding-right: 13px;
}
.assessment-input-popover-item {
  padding-bottom: 10px;
  padding-top: 10px;
}
</style>
